import type { ChannelTagDataObject } from './service';

// TODO: check how it's used in admin and if this is correct, if its different fix it
export type ChannelTag = {
  id: string;
  name: string;
  organizationId: string;
};

// TODO: check how it's used in admin and if this is correct, if its different fix it
export const getTagData = (data: ChannelTagDataObject): ChannelTag => ({
  id: data.id,
  name: data.name,
  organizationId: data.organization_id,
});
